// extracted by mini-css-extract-plugin
export default {"icon":"ai-icon-tooltip_icon__IiuHT"};